import React from "react";

const SelectedFolders = React.createContext({});

export const SelectedFoldersProvider = SelectedFolders.Provider;
export default SelectedFolders;
